import axios from 'axios';

import type {
  ClaimFlagConfigurationCreateJson,
  ClaimFlagConfigurationModel,
  ClaimFlagConfigurationUpdateJson,
} from '~/server_shared/openapi/data-contracts';

const getBaseUrl = (organizationId: number) => `/sysconfig/api/v1/organizations/${organizationId}/claim_flag`;

export const createClaimFlagConfiguration = async (
  organizationId: number,
  values: ClaimFlagConfigurationCreateJson
): Promise<ClaimFlagConfigurationModel> => {
  const url = getBaseUrl(organizationId);
  const response = await axios.post<ClaimFlagConfigurationModel>(url, values);
  return response.data;
};

export const updateClaimFlagConfiguration = async (
  organizationId: number,
  flagKey: string,
  updates: ClaimFlagConfigurationUpdateJson
): Promise<ClaimFlagConfigurationModel> => {
  const url = `${getBaseUrl(organizationId)}/${flagKey}`;
  const response = await axios.patch<ClaimFlagConfigurationModel>(url, updates);
  return response.data;
};

// One atomic reorder: the full ordered key list replaces the stored order in a single call.
export const reorderClaimFlagConfigurations = async (organizationId: number, flagKeys: string[]): Promise<void> => {
  const url = `${getBaseUrl(organizationId)}/order`;
  await axios.put<void>(url, { flag_keys: flagKeys });
};
